import { RankedTester, and, isStringControl, rankWith, optionIs } from "@jsonforms/core";

export const GalleryMidiaStringTest: RankedTester = rankWith(
  3,
  and(isStringControl, optionIs("mediaGallery", true))
);

export default GalleryMidiaStringTest;
